import {
  annotationToolApiV1,
  getAnnotationToolBasePath,
  type AllocationSummaryResponse,
  type BooleanResponse,
  type CountResponse,
  type ObjectResponse,
} from '@verantos-dev/core-annotation-tool';

import { ANNOTATION_DASHBOARD_TAG } from '../constants';

export const dashboardApiSlice = annotationToolApiV1
  .enhanceEndpoints({
    addTagTypes: [ANNOTATION_DASHBOARD_TAG],
  })
  .injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
      getBatchesCount: builder.query<ObjectResponse<CountResponse>, void>({
        query: () => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = '/internal-message-gateway' + basePath;
          return `${tempPath}/work-queue/batches/review-count`;
        },
        providesTags: [ANNOTATION_DASHBOARD_TAG],
      }),

      getMyProjectsCount: builder.query<ObjectResponse<CountResponse>, void>({
        query: () => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = '/internal-message-gateway' + basePath;
          return `${tempPath}/work-queue/projects/assigned-count`;
        },
        providesTags: [ANNOTATION_DASHBOARD_TAG],
      }),

      getTotalProjectsCount: builder.query<ObjectResponse<CountResponse>, void>({
        query: () => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = '/internal-message-gateway' + basePath;
          return `${tempPath}/projects/count`;
        },
        providesTags: [ANNOTATION_DASHBOARD_TAG],
      }),

      getOrganizationsCount: builder.query<ObjectResponse<CountResponse>, void>({
        query: () => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = '/internal-message-gateway' + basePath;
          return `${tempPath}/organizations/count`;
        },
        providesTags: [ANNOTATION_DASHBOARD_TAG],
      }),

      getConditionsCount: builder.query<ObjectResponse<CountResponse>, void>({
        query: () => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = '/internal-message-gateway' + basePath;
          return `${tempPath}/conditions/count`;
        },
        providesTags: [ANNOTATION_DASHBOARD_TAG],
      }),

      getHasAnnotationTasks: builder.query<ObjectResponse<BooleanResponse>, void>({
        query: () => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = '/internal-message-gateway' + basePath;
          return `${tempPath}/work-queue/has-annotation-work`;
        },
        providesTags: [ANNOTATION_DASHBOARD_TAG],
      }),

      getHasSupervisionBatches: builder.query<ObjectResponse<BooleanResponse>, void>({
        query: () => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = '/internal-message-gateway' + basePath;
          return `${tempPath}/work-queue/has-supervision-work`;
        },
        providesTags: [ANNOTATION_DASHBOARD_TAG],
      }),

      getAnnotationAllocationSummary: builder.query<
        ObjectResponse<AllocationSummaryResponse>,
        {
          projectId?: string;
          batchId?: string;
        }
      >({
        query: ({ projectId, batchId }) => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = '/internal-message-gateway' + basePath;
          const params = new URLSearchParams();
          if (projectId) params.append('project_id', projectId);
          if (batchId) params.append('batch_id', batchId);
          const queryString = params.toString() ? `?${params.toString()}` : '';
          return `${tempPath}/work-queue/annotation-allocations/summary${queryString}`;
        },
        providesTags: [ANNOTATION_DASHBOARD_TAG],
      }),
    }),
  });

export const {
  useGetBatchesCountQuery,
  useGetMyProjectsCountQuery,
  useGetTotalProjectsCountQuery,
  useGetOrganizationsCountQuery,
  useGetConditionsCountQuery,
  useGetHasAnnotationTasksQuery,
  useGetHasSupervisionBatchesQuery,
  useGetAnnotationAllocationSummaryQuery,
} = dashboardApiSlice;
